<template>
  <div v-if="featuredShops.length > 0" class="w-full mb-6 md:mb-10 overflow-hidden">
    <h1 class="text-[24px] md:text-[30px] text-grey-light-900 mb-4 font-semibold" v-if="showTitle">Featured Stores</h1>

    <Carousel class="w-full relative overflow-hidden" :opts="{ loop: featuredShops.length > 2 }">
      <CarouselContent class="flex gap-x-4">
        <CarouselItem
          v-for="store in featuredShops"
          :key="store.id"
          class="flex-shrink-0 w-full sm:max-w-[360px] md:max-w-[480px] lg:max-w-[540px]"
        >
          <div class="mx-auto">
            <FeaturedStoreCard
              :id="store.id"
              :name="store.name"
              :logo="store.logo"
              :createdAt="store.createdAt"
              :loading="false"
              @click="$emit('openStore', store)"
            />
          </div>
        </CarouselItem>
      </CarouselContent>

      <CarouselPrevious
        class="flex items-center justify-center absolute top-1/2 -translate-y-1/2 left-4 text-white bg-black/40 rounded-full p-2 hover:bg-black/60 transition"
      />
      <CarouselNext
        class="flex items-center justify-center absolute top-1/2 -translate-y-1/2 right-4 text-white bg-black/40 rounded-full p-2 hover:bg-black/60 transition"
      />

      <CarouselDotButtons class="mt-4 absolute bottom-4 left-1/2 -translate-x-1/2" selected-class="border-white" />
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import FeaturedStoreCard from '@/components/shopper/stores/FeaturedStoreCard.vue';
import {
  Carousel,
  CarouselContent,
  CarouselDotButtons,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';
import { useShopsStore } from '@/stores/shops';
import { storeToRefs } from 'pinia';
import type { ModelMerchantShopDirectoryShopV2 } from '@layup/api-sdk';

defineProps<{
  showTitle?: boolean;
}>();

defineEmits<{
  openStore: [store: ModelMerchantShopDirectoryShopV2];
}>();

const { featuredShops } = storeToRefs(useShopsStore());
</script>
